export const initialState = () => ({
  filter: {
    name: null,
    cpf: "",
    email: null,
    chain: [],
    pos: [],
    start_date: null,
    end_date: null
  },
  suspensionTypes: []
})
